export const NODE_TYPE_ORDER = [
  'agent',
  'input',
  'output',
  'tool',
  'logic',
  'governance',
  'data',
];

/** MCP server categories expanded by default in the sidebar and popovers. */
export const DEFAULT_EXPANDED_MCP_SERVERS = ['Web Search'];

export const isPickerHiddenNode = (node: {
  picker_hidden?: boolean;
  show?: boolean;
}) => node.picker_hidden === true || node.show === false;

export const NODE_TYPE_LABELS: Record<string, string> = {
  agent: 'Agents',
  input: 'Inputs',
  output: 'Outputs',
  tool: 'Tools',
  logic: 'Logic',
  governance: 'Governance',
  data: 'Data',
};

// --- if/else (Phase 8b) -----------------------------------------------------
/**
 * Extra words the Add Nodes search matches besides the display name, so a
 * first-time user who types "if", "condition" or "branch" finds the right
 * node without knowing its name.
 */
export const NODE_SEARCH_ALIASES: Record<string, readonly string[]> = {
  if_node: ['if', 'then', 'else', 'otherwise', 'condition', 'branch', 'route'],
  switch_node: ['switch', 'case', 'match', 'condition', 'branch', 'route'],
  validate_node: ['check', 'assert', 'schema', 'require'],
  repeat_until_node: ['loop', 'repeat', 'until', 'retry', 'while'],
  map_node: ['for each', 'foreach', 'for', 'each', 'map', 'loop', 'items'],
};

/**
 * Within the Logic category, show the simpler node first: If / Else before
 * Switch. Nodes not listed keep their catalog order after these.
 */
export const LOGIC_NODE_ORDER: readonly string[] = ['if_node', 'switch_node'];

export const matchesNodeSearch = (
  node: { node_id?: string; display_name: string },
  query: string,
): boolean => {
  const needle = query.trim().toLowerCase();
  if (!needle) return true;
  if (node.display_name.toLowerCase().includes(needle)) return true;
  const aliases = node.node_id ? NODE_SEARCH_ALIASES[node.node_id] : undefined;
  return aliases?.some((alias) => alias.includes(needle)) ?? false;
};

export const sortLogicNodes = <T extends { node_id?: string }>(
  nodes: readonly T[],
): T[] => {
  const rank = (node: T): number => {
    const index = node.node_id ? LOGIC_NODE_ORDER.indexOf(node.node_id) : -1;
    return index === -1 ? LOGIC_NODE_ORDER.length : index;
  };
  return [...nodes].sort((a, b) => rank(a) - rank(b));
};
// --- end if/else ------------------------------------------------------------
